import { render, staticRenderFns } from "./CreateSecurityConcern.vue?vue&type=template&id=daeb60dc&scoped=true"
import script from "./CreateSecurityConcern.vue?vue&type=script&lang=js"
export * from "./CreateSecurityConcern.vue?vue&type=script&lang=js"
import style0 from "./CreateSecurityConcern.vue?vue&type=style&index=0&id=daeb60dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daeb60dc",
  null
  
)

export default component.exports